<template>
  <div class="bind-phone-wrapper">
    <h2 class="">手机绑定</h2>
    <a-form-model
      :model="loginForm"
      ref="loginForm"
      :rules="rules"
      class="login-form"
      v-bind="layout"
    >
      <a-form-model-item prop="phone" label="手机号">
        <a-input
          class="set-input"
          v-model.trim="loginForm.phone"
          :size="formSize"
        >
        </a-input>
      </a-form-model-item>
      <a-form-model-item
        prop="smsCode"
        class="random"
        style="margin-bottom: 10px"
        label="验证码"
      >
        <a-input
          class="set-input"
          :size="formSize"
          v-model.trim="loginForm.smsCode"
          type="text"
        >
        </a-input>
        <a-button
          class="set-button"
          block
          type="primary"
          :size="formSize"
          @click="getSendCode"
          :disabled="isSendCode"
        >
          获取验证码
        </a-button>
      </a-form-model-item>
      <div class="hint">
        <span v-if="isSendCode">{{ time }}秒后重新发送验证码</span>
      </div>

      <a-form-model-item> </a-form-model-item>
    </a-form-model>
    <div class="login-button">
      <a-button
        block
        type="primary"
        :size="formSize"
        @click="handleSubmit"
        :loading="loading"
      >
        绑定
      </a-button>
      <!-- <div class="flex-j-b flex-a-c">
        <div style="color:#8c8c8c;">
          登录即代表您已阅读并同意
          <router-link to="/privacy">《隐私声明》</router-link>
        </div>
      </div> -->
    </div>
    <!-- <div class="third-party">
      <a-divider class="wechat-login">微信登录</a-divider>
      <img @click="wechatLogin" src="~@/assets/weixin.png" width="40" />
    </div> -->
    <img class="footer-logo" src="~@/assets/eye/footer-logo.png" width="400" />
  </div>
</template>
<script>
import { sendCodeByWechat } from "@/api/user.js";
import { mapGetters, mapActions } from "vuex";
import rolesMixin from "@/mixins/roles";

export default {
  mixins: [rolesMixin],
  data() {
    return {
      privacy: false,
      isSendCode: false,
      isauthCode: true,
      time: 120,
      timer: null,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18 }
      },
      loginForm: {
        phone: "",
        smsCode: ""
      },
      rules: {
        phone: [
          {
            required: true,
            message: "请输入账户",
            trigger: "blur"
          }
        ],
        smsCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ]
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters(["formSize"])
  },
  methods: {
    ...mapActions({
      login: "loginAddSmsCode",
      handleLogin: "wechatLogin",
      bindPhoneWechatLogin: "bindPhoneWechatLogin"
    }),
    getSendCode() {
      if (!/^1[3456789]\d{9}$/.test(this.loginForm.phone)) {
        this.$message.error("请输入正确手机号");
        return;
      }
      const params = {
        phone: this.loginForm.phone,
        type: "bindLogin"
      };
      sendCodeByWechat(params)
        .then(res => {
          if (res.code === 1) {
            this.isSendCode = true;
            this.time = 120;
            if (this.isSendCode) {
              this.timer = setInterval(() => {
                this.time--;
                if (this.time <= 0) {
                  this.isSendCode = false;
                  clearInterval(this.timer);
                }
              }, 1000);
            }
            console.log(res);
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    handleSubmit() {
      // if (!this.privacy) {
      //   return this.$message.error("请认真阅读并勾选隐私条款");
      // }
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.bindPhoneWechatLogin({
            ...this.loginForm,
            source: "EYE_PC_LOGIN"
          })
            .then(res => {
              console.log(res);
              // 去首页
              this.$router.push("/applySubject");
            })
            .catch(e => {
              this.loading = false;
              console.error(e);
            });
        }
      });
    },
    wechatLogin() {
      const appId = process.env.VUE_APP_APPID;
      const redirectUri = process.env.VUE_APP_REDIRECT_URI;
      window.location = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login&state=EYE_PC_LOGIN#wechat_redirect`;
    }
  }
};
</script>
<style lang="less">
.random .ant-form-item-children {
  display: flex;
  justify-content: space-between;
}
</style>
<style lang="less" scoped>
.bind-phone-wrapper {
  position: relative;
  background: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h2 {
    width: 375px;
    margin: 0 auto;
    text-align: left;
    font-weight: bold;
    margin-bottom: 20px;
  }
  min-height: 280px;
  .login-form {
    width: 375px;
    padding: 0 5px;
    box-sizing: border-box;
    margin: 0 auto;
    .set-input {
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
      border-radius: 0 !important;
    }
    // &/deep/.has-error:focus {
    //   border-top: none !important;
    //   border-left: none !important;
    //   border-right: none !important;
    //   border-radius: 0 !important;
    // }
    .random-input {
      width: 260px;
      margin-right: 10px;
    }
    .set-button {
      background: #ffffff;
      color: #234b86;
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
      border-bottom: 1px solid #d9d9d9;
      box-shadow: none;
    }
    .hint {
      margin-bottom: 24px;
      text-align: right;
    }
    .code-img {
      cursor: pointer;
    }
  }
  .third-party {
    margin: 0 auto;
    width: 375px;
    text-align: center;
    .wechat-login {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.2);
    }
  }
  .footer-logo {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
  }
  .login-button {
    width: 375px;
    margin: 0 auto 20px;
  }
  .ant-input:focus,
  .ant-input:hover,
  .has-error .ant-input {
    // 取消输入框默认效果
    border-bottom: 1px solid #d9d9d9 !important;
    box-shadow: none;
  }
  .ant-btn::after {
    // 取消ant按钮点击默认效果
    border: 0 none;
    opacity: 0;
    animation: none 0 ease 0 1 normal;
  }
}
</style>
